import { formatCurrency } from "../../../../components/common/Converter";
import { payrollCaseRegistry } from "./payslip-cases/PayslipCases";

export const _withItem =
  (item = {}) =>
  (caseName) => {
    const caseHandler = payrollCaseRegistry[caseName];
    return typeof caseHandler === "function" ? caseHandler(item) : false;
  };
export const _sumDeductions = (deductions) => {
  if (!Array.isArray(deductions)) return 0;

  const excludedKeys = ["tax", "2", "5", "10"];

  return deductions.reduce((total, item) => {
    const [key, value] = item.split(":").map((s) => s.trim());
    const amount = parseFloat(value);

    if (excludedKeys.includes(key) || isNaN(amount)) return total;

    return total + amount;
  }, 0);
};

// utils/employeeUtils.js

export const _getFullName = (employee = {}) => {
  const { surname = "", Firstname = "", Middlename = "" } = employee;
  return `${surname} ${Firstname} ${Middlename}`.trim();
};

export const fromCamelCase = (str) => {
  if (!str) return "";
  return (
    str
      // Insert space before capital letters (except first letter)
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // Capitalize the first letter of each word
      .replace(/\b\w/g, (match) => match.toUpperCase())
  );
};

export const _formatPayrollPeriod = (startDateStr, endDateStr) => {
  if (!startDateStr || !endDateStr) return "";

  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const format = (date) =>
    date.toLocaleString("en-US", { month: "long", year: "numeric" });

  const startFormatted = format(startDate);
  const endFormatted = format(endDate);

  return startFormatted === endFormatted
    ? startFormatted
    : `${startFormatted} - ${endFormatted}`;
};

export const displayAmount = (value) => {
  const num = Number(value ?? 0);
  return num === 0 ? "-" : formatCurrency(num.toString());
};

export const _safeAdd = (...values) =>
  values.reduce((sum, val) => sum + Number(val ?? 0), 0);
export const _safeSubtract = (...values) =>
  values.reduce(
    (result, val, index) =>
      index === 0 ? Number(val ?? 0) : result - Number(val ?? 0),
    0
  );
